import React, { useState } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE', accentDark:'#2E8B47',
 bg:'#F0F4F0', surface:'#FFFFFF',
 border:'#E2E8E2', border2:'#CDD8CD',
 text:'#1A2E1E', text2:'#3D5E44', text3:'#7A9A80',
 amber:'#D4840F', amberBg:'#FEF6E7', amberBorder:'#F0D499',
 red:'#C83333', redBg:'#FDEAEA', redBorder:'#F0B8B8',
 blue:'#2563A8', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 orange:'#E05A00', orangeBg:'#FEF0E6',
 pink:'#E91E63', pinkBg:'#FCE4EC',
 dark:'#0F1E14', dark2:'#1A3A22',
};

const inr = n => '₹'+Number(Math.round(n)||0).toLocaleString('en-IN');

const ALERTS = [
 {id:1,tone:'red', msg:"New lead 'Priya Events' not contacted — 22 min elapsed (>15 min SLA)"},
 {id:2,tone:'amber',msg:"Wedding enquiry from 'Kapoor Family' pending 28 hours — needs follow-up"},
 {id:3,tone:'amber',msg:"Room 103 marked Dirty for 2h 15min — housekeeping not assigned"},
 {id:4,tone:'red', msg:"Paneer stock below reorder level — 40kg remaining, reorder at 60kg"},
 {id:5,tone:'amber',msg:"Rose garden spray due today — last spray was 14 days ago"},
];

const MONTHLY = [
 {m:'Jan',r:2540000},{m:'Feb',r:2130000},{m:'Mar',r:1500000},
 {m:'Apr',r:1365000},{m:'May',r:1905000},{m:'Jun',r:1050000},{m:'Jul',r:1170000},
];

const DEPTS = [
 {id:'sales_crm', name:'Sales CRM', value:'8 Hot Leads', sub:'₹62L Pipeline', c:C.red, g:`linear-gradient(135deg,#E05050,${C.red})`},
 {id:'bookings', name:'Bookings', value:'3 Today', sub:'24 Confirmed', c:C.blue, g:`linear-gradient(135deg,#3070D0,${C.blue})`},
 {id:'rooms', name:'Rooms / PMS', value:'4/12 Occ', sub:'33% Occupancy', c:C.purple, g:`linear-gradient(135deg,#8060C0,${C.purple})`},
 {id:'events', name:'Events', value:'2 Today', sub:'8 This Week', c:C.accent, g:`linear-gradient(135deg,${C.accent},${C.accentDark})`},
 {id:'inventory', name:'Kitchen & Stock', value:'8 Low Stock', sub:'Reorder Needed', c:C.amber, g:`linear-gradient(135deg,#F0A030,${C.amber})`},
 {id:'housekeeping',name:'Housekeeping', value:'3 Pending', sub:'Room 103 Dirty', c:C.teal, g:`linear-gradient(135deg,#2A8A8A,${C.teal})`},
 {id:'horticulture',name:'Horticulture', value:'2 Due Today', sub:'Rose Spray Due', c:'#558B2F', g:`linear-gradient(135deg,#558B2F,#3A6020)`},
 {id:'construction',name:'Construction', value:'3 Active', sub:'1 Milestone Late',c:C.orange, g:`linear-gradient(135deg,#F07030,${C.orange})`},
 {id:'accounts', name:'Accounts & GST', value:'₹21.8L', sub:'Outstanding', c:C.blue, g:`linear-gradient(135deg,#3070D0,${C.blue})`},
 {id:'hr', name:'HR & Staff', value:'54 Staff', sub:'4 Absent Today', c:C.purple, g:`linear-gradient(135deg,#8060C0,${C.purple})`},
 {id:'marketing', name:'Marketing', value:'195 Leads', sub:'+19 This Week', c:C.pink, g:`linear-gradient(135deg,#E050A0,${C.pink})`},
 {id:'reports', name:'Reports', value:'6 Reports', sub:'View Analytics', c:C.teal, g:`linear-gradient(135deg,#2A8A8A,${C.teal})`},
];

const EVENTS = [
 {name:'TechCorp Day Out', type:'Corporate', pax:280,time:'9:00 AM', venue:'Adventure Garden', status:'Confirmed',c:C.blue},
 {name:'GreenVille School', type:'School Picnic',pax:200,time:'9:30 AM', venue:'Pilkhan Garden', status:'Confirmed',c:C.accent},
 {name:'Kapoor Wedding', type:'Wedding', pax:350,time:'10:00 AM',venue:'Petunia Hall', status:'Reserved', c:C.pink},
 {name:'ABC Pharma MICE', type:'Conference', pax:120,time:'9:00 AM', venue:'Conference Room', status:'Hot Lead', c:C.amber},
];

const ROOMS=[101,102,103,104,105,106,107,108,109,110,111,112];
const OCC=[101,103,106,110];
const DIRTY=[103];

export default function NewDashboard({setTab}) {
 const [dismissed,setDismissed] = useState([]);
 const visible = ALERTS.filter(a=>!dismissed.includes(a.id));
 const maxR = Math.max(...MONTHLY.map(d=>d.r));

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text,background:C.bg,minHeight:'100vh'}}>

 {/* ── HERO BANNER ── */}
 <div style={{background:`linear-gradient(135deg,${C.dark} 0%,${C.dark2} 55%,#0A2010 100%)`,padding:'28px 32px',position:'relative',overflow:'hidden'}}>
 <div style={{position:'absolute',top:-80,right:-60,width:320,height:320,borderRadius:'50%',background:'rgba(58,175,88,.05)',pointerEvents:'none'}}/>
 <div style={{position:'absolute',bottom:-100,right:200,width:240,height:240,borderRadius:'50%',background:'rgba(58,175,88,.04)',pointerEvents:'none'}}/>
 <div style={{position:'relative'}}>

 {/* Title row */}
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24}}>
 <div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.16em',marginBottom:6}}> Botanix Nature Resort — Command Centre</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:34,fontWeight:800,color:'#fff',letterSpacing:'-.03em',marginBottom:4}}>Botanix Command Centre</div>
 <div style={{fontSize:13,color:'rgba(255,255,255,.35)'}}>{new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:6}}>Monthly Revenue</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:36,fontWeight:800,color:C.accent,letterSpacing:'-.03em'}}>₹18,40,000</div>
 <div style={{display:'flex',alignItems:'center',gap:8,justifyContent:'flex-end',marginTop:6}}>
 <div style={{width:120,height:6,background:'rgba(255,255,255,.1)',borderRadius:99}}>
 <div style={{height:6,width:'74%',background:`linear-gradient(90deg,${C.accent},#50D080)`,borderRadius:99,boxShadow:`0 0 8px ${C.accent}`}}/>
 </div>
 <span style={{fontSize:12,fontWeight:700,color:C.accent}}>74% of ₹25L target</span>
 </div>
 </div>
 </div>

 {/* 8 KPI boxes */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(8,1fr)',gap:10,marginBottom:20}}>
 {[
 {l:'Room Occupancy',v:'4/12', s:'33% occupied', ic:'',c:'#64B5F6', t:'rooms'},
 {l:'Today Revenue', v:'₹48,500', s:'Live today', ic:'₹', c:C.accent, t:'accounts'},
 {l:'Today Bookings',v:'3', s:'24 confirmed', ic:'',c:'#CE93D8', t:'bookings'},
 {l:'Today Events', v:'2', s:'8 this week', ic:'',c:'#81C784', t:'events'},
 {l:'Pending', v:'8', s:'Needs action', ic:'',c:'#FFB347', t:'bookings'},
 {l:'Check-ins', v:'2', s:'Arriving today', ic:'',c:'#80CBC4', t:'rooms'},
 {l:'Alerts', v:visible.length,s:'Need attention',ic:'',c:'#EF9A9A', t:'dashboard'},
 {l:'Staff Present', v:'50/54', s:'4 absent today', ic:'',c:'#B39DDB', t:'hr'},
 ].map(k=>(
 <div key={k.l} onClick={()=>setTab(k.t)}
 style={{padding:'14px 12px',background:'rgba(255,255,255,.06)',borderRadius:14,border:'1px solid rgba(255,255,255,.08)',cursor:'pointer',textAlign:'center',transition:'all .2s'}}>
 <div style={{fontSize:22,marginBottom:6}}>{k.ic}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:24,fontWeight:800,color:k.c,letterSpacing:'-.02em',marginBottom:3}}>{k.v}</div>
 <div style={{fontSize:9,color:'rgba(255,255,255,.35)',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:2}}>{k.l}</div>
 <div style={{fontSize:10,color:k.c,fontWeight:600}}>{k.s}</div>
 </div>
 ))}
 </div>

 {/* Mini bar chart + donuts */}
 <div style={{display:'grid',gridTemplateColumns:'1fr auto auto',gap:20,alignItems:'end'}}>
 <div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8}}>Monthly Revenue Trend 2026</div>
 <div style={{display:'flex',alignItems:'flex-end',gap:4,height:48}}>
 {MONTHLY.map((d,i)=>(
 <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:2}}>
 <div style={{width:'100%',background:i===MONTHLY.length-1?C.accent:C.accent+'40',borderRadius:'3px 3px 0 0',height:`${Math.max(4,(d.r/maxR)*44)}px`}}/>
 <div style={{fontSize:7,color:'rgba(255,255,255,.3)',fontWeight:600}}>{d.m}</div>
 </div>
 ))}
 </div>
 </div>
 {[[33,'Occupancy',C.accent],[74,'vs Target','#64B5F6']].map(([p,l,c])=>(
 <div key={l} style={{textAlign:'center'}}>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}>{l}</div>
 <svg width={60} height={60} viewBox="0 0 60 60">
 <circle cx={30} cy={30} r={24} fill="none" stroke="rgba(255,255,255,.1)" strokeWidth={6}/>
 <circle cx={30} cy={30} r={24} fill="none" stroke={c} strokeWidth={6}
 strokeDasharray={2*Math.PI*24} strokeDashoffset={2*Math.PI*24*(1-p/100)}
 strokeLinecap="round" style={{transform:'rotate(-90deg)',transformOrigin:'center'}}/>
 <text x={30} y={34} textAnchor="middle" fontSize={11} fontWeight={700} fill={c}>{p}%</text>
 </svg>
 </div>
 ))}
 </div>
 </div>
 </div>

 {/* ── SECOND GREEN BAND ── */}
 <div style={{background:`linear-gradient(135deg,#1A4A20,#243828)`,padding:'12px 32px',display:'flex',gap:8,overflowX:'auto',alignItems:'center'}}>
 <span style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.1em',whiteSpace:'nowrap',marginRight:8}}>Quick Navigate:</span>
 {[
 {l:'Sales CRM',t:'sales_crm',ic:''},{l:'Bookings',t:'bookings',ic:''},
 {l:'Rooms',t:'rooms',ic:''},{l:'Events',t:'events',ic:''},
 {l:'Kitchen',t:'kitchen_mgmt',ic:''},{l:'Housekeeping',t:'housekeeping',ic:''},
 {l:'Accounts',t:'accounts',ic:''},{l:'HR',t:'hr',ic:''},
 {l:'Reports',t:'reports',ic:''},{l:'Horticulture',t:'horticulture',ic:''},
 {l:'Construction',t:'construction',ic:''},{l:'Marketing',t:'marketing',ic:''},
 ].map(q=>(
 <button key={q.t} onClick={()=>setTab(q.t)}
 style={{padding:'6px 14px',borderRadius:99,background:'rgba(255,255,255,.07)',border:'1px solid rgba(255,255,255,.12)',color:'rgba(255,255,255,.7)',fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:5}}>
 {q.ic} {q.l}
 </button>
 ))}
 </div>

 <div style={{padding:'24px 32px'}}>

 {/* ── ALERTS ── */}
 {visible.length>0&&(
 <div style={{marginBottom:24}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text}}>
 Active Alerts
 <span style={{fontSize:13,fontWeight:600,color:C.red,background:C.redBg,padding:'2px 10px',borderRadius:99,marginLeft:8}}>{visible.length}</span>
 </div>
 <button onClick={()=>setDismissed(ALERTS.map(a=>a.id))} style={{fontSize:12,color:C.text3,background:'none',border:`1px solid ${C.border2}`,padding:'5px 14px',borderRadius:8,cursor:'pointer'}}>Dismiss All</button>
 </div>
 {visible.map(a=>(
 <div key={a.id} style={{display:'flex',alignItems:'center',gap:12,padding:'11px 16px',background:a.tone==='red'?C.redBg:C.amberBg,borderRadius:10,border:`1px solid ${a.tone==='red'?C.redBorder:C.amberBorder}`,marginBottom:8}}>
 <span style={{fontSize:16}}>{a.icon}</span>
 <span style={{fontSize:12,color:a.tone==='red'?C.red:C.amber,flex:1,fontWeight:500}}>{a.msg}</span>
 <button onClick={()=>setDismissed(p=>[...p,a.id])} style={{background:'none',border:'none',cursor:'pointer',color:a.tone==='red'?C.red:C.amber,fontSize:16,opacity:.6}}></button>
 </div>
 ))}
 </div>
 )}

 {/* ── TODAY'S EVENTS + ROOMS ── */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20,marginBottom:24}}>

 {/* Events */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}>
 <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentDark})`,padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:'#fff'}}> Today's Events & Bookings</div>
 <button onClick={()=>setTab('events')} style={{padding:'6px 14px',background:'rgba(255,255,255,.2)',border:'none',borderRadius:9,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer'}}>View All →</button>
 </div>
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 16px 16px'}}>
 {EVENTS.map((ev,i)=>(
 <div key={i} onClick={()=>setTab('events')} style={{padding:'13px 18px',borderBottom:i<EVENTS.length-1?`1px solid ${C.border}`:'none',cursor:'pointer',display:'flex',alignItems:'center',gap:14}}>
 <div style={{width:44,height:44,borderRadius:12,background:ev.c+'15',border:`1.5px solid ${ev.c}33`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0}}>
 {ev.type==='Wedding'?'':ev.type==='Corporate'?'':ev.type==='School Picnic'?'':''}
 </div>
 <div style={{flex:1}}>
 <div style={{fontWeight:700,fontSize:13,color:C.text,marginBottom:2}}>{ev.name}</div>
 <div style={{fontSize:11,color:C.text3}}>{ev.time} · {ev.venue} · {ev.pax} pax</div>
 </div>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:10,fontWeight:600,color:ev.c,background:ev.c+'15',border:`1px solid ${ev.c}33`}}>{ev.status}</span>
 </div>
 ))}
 </div>
 </div>

 {/* Rooms */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}>
 <div style={{background:`linear-gradient(135deg,${C.blue},#1A4A8A)`,padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:'#fff'}}> Room Status — Live</div>
 <button onClick={()=>setTab('rooms')} style={{padding:'6px 14px',background:'rgba(255,255,255,.2)',border:'none',borderRadius:9,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer'}}>Manage →</button>
 </div>
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'16px 18px'}}>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:14}}>
 {ROOMS.map(n=>{
 const occ=OCC.includes(n),dirty=DIRTY.includes(n);
 return (
 <div key={n} onClick={()=>setTab('rooms')} style={{padding:'10px 8px',borderRadius:10,background:dirty?C.amberBg:occ?C.blueBg:C.accentLight,border:`1.5px solid ${dirty?C.amber:occ?C.blue:C.accent}`,textAlign:'center',cursor:'pointer'}}>
 <div style={{fontSize:11,fontWeight:700,color:dirty?C.amber:occ?C.blue:C.accent}}>Room {n}</div>
 <div style={{fontSize:9,color:dirty?C.amber:occ?C.blue:C.accent,marginTop:2}}>{dirty?' Dirty':occ?' Occ':' Free'}</div>
 </div>
 );
 })}
 </div>
 <div style={{display:'flex',gap:14,justifyContent:'center'}}>
 {[['Free',C.accent,C.accentLight,8],['Occupied',C.blue,C.blueBg,4],['Dirty',C.amber,C.amberBg,1]].map(([l,c,bg,v])=>(
 <div key={l} style={{display:'flex',alignItems:'center',gap:5}}>
 <div style={{width:10,height:10,borderRadius:3,background:bg,border:`1.5px solid ${c}`}}/>
 <span style={{fontSize:11,color:C.text3}}>{l}: <strong style={{color:c}}>{v}</strong></span>
 </div>
 ))}
 </div>
 </div>
 </div>
 </div>

 {/* ── DEPARTMENT GRID ── */}
 <div style={{marginBottom:24}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:C.text,marginBottom:16}}>
 Department Status &nbsp;
 <span style={{fontSize:12,fontWeight:500,color:C.text3}}>Click any department to open</span>
 </div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14}}>
 {DEPTS.map(d=>(
 <div key={d.id} onClick={()=>setTab(d.id)} style={{borderRadius:14,overflow:'hidden',cursor:'pointer',boxShadow:'0 3px 12px rgba(0,0,0,.08)',border:`1px solid ${d.c}22`,transition:'all .2s'}}>
 <div style={{background:d.g,padding:'14px 16px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
 <div style={{fontSize:28}}>{d.icon}</div>
 <div style={{background:'rgba(255,255,255,.15)',borderRadius:99,padding:'3px 10px',fontSize:11,fontWeight:700,color:'#fff'}}>Open →</div>
 </div>
 <div style={{background:C.surface,padding:'12px 16px',borderTop:`3px solid ${d.c}`}}>
 <div style={{fontWeight:800,fontSize:14,color:C.text,marginBottom:3}}>{d.name}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:d.c,marginBottom:2}}>{d.value}</div>
 <div style={{fontSize:11,color:C.text3}}>{d.sub}</div>
 </div>
 </div>
 ))}
 </div>
 </div>

 {/* ── BOTTOM 3 CARDS ── */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16}}>

 {/* Revenue */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}>
 <div style={{background:`linear-gradient(135deg,${C.dark2},#243828)`,padding:'14px 18px'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:'#fff'}}> Revenue Breakdown</div>
 </div>
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'16px 18px'}}>
 {[['Rooms',840000,C.blue],['F&B',320000,C.amber],['Events',1200000,C.accent],['Activities',180000,C.purple]].map(([l,v,c])=>(
 <div key={l} style={{marginBottom:12}}>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:12,marginBottom:4}}>
 <span style={{fontWeight:600,color:C.text}}>{l}</span>
 <span style={{fontWeight:700,color:c}}>₹{(v/100000).toFixed(1)}L</span>
 </div>
 <div style={{height:6,background:C.border,borderRadius:99}}>
 <div style={{height:6,width:`${Math.round(v/2540000*100)}%`,background:c,borderRadius:99}}/>
 </div>
 </div>
 ))}
 <button onClick={()=>setTab('reports')} style={{width:'100%',marginTop:8,padding:'8px',background:C.accentLight,border:`1px solid ${C.accent}`,borderRadius:9,color:C.accent,fontSize:12,fontWeight:600,cursor:'pointer'}}> Full Reports →</button>
 </div>
 </div>

 {/* Schedule */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}>
 <div style={{background:`linear-gradient(135deg,${C.purple},#4A2880)`,padding:'14px 18px'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:'#fff'}}> Today's Schedule</div>
 </div>
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'16px 18px'}}>
 {[
 {t:'9:00 AM', e:'TechCorp Day Out Check-in', c:C.blue},
 {t:'9:30 AM', e:'GreenVille School Picnic', c:C.accent},
 {t:'11:00 AM',e:'Accounts Review Meeting', c:C.amber},
 {t:'2:00 PM', e:'Kapoor Wedding Site Visit', c:C.pink},
 {t:'4:00 PM', e:'Kitchen Stock Audit', c:C.orange},
 {t:'6:00 PM', e:'TechCorp Check-out', c:C.blue},
 ].map((s,i)=>(
 <div key={i} style={{display:'flex',gap:10,marginBottom:10,alignItems:'flex-start'}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,width:52,flexShrink:0,marginTop:2}}>{s.t}</div>
 <div style={{width:3,borderRadius:99,background:s.c,alignSelf:'stretch',minHeight:20,flexShrink:0}}/>
 <div style={{fontSize:12,color:C.text,fontWeight:500,lineHeight:1.3}}>{s.e}</div>
 </div>
 ))}
 </div>
 </div>

 {/* Needs Attention */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(0,0,0,.08)'}}>
 <div style={{background:`linear-gradient(135deg,${C.red},#A02020)`,padding:'14px 18px'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:'#fff'}}> Needs Attention</div>
 </div>
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'16px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {[
 {ic:'',msg:'Room 103 dirty — 2hrs unattended', c:C.amber, t:'housekeeping'},
 {ic:'',msg:'Paneer stock critical — 40kg left', c:C.red, t:'inventory'},
 {ic:'',msg:'4 staff absent without approval', c:C.red, t:'hr'},
 {ic:'',msg:'ABC Tech payment overdue — ₹5.76L', c:C.amber, t:'accounts'},
 {ic:'',msg:'Rose garden spray overdue 14 days', c:C.accent,t:'horticulture'},
 {ic:'',msg:'Cottage A foundation delayed 3 days', c:C.orange,t:'construction'},
 ].map((a,i)=>(
 <div key={i} onClick={()=>setTab(a.t)} style={{display:'flex',gap:8,padding:'8px 10px',background:C.bg,borderRadius:9,border:`1px solid ${a.c}22`,cursor:'pointer',alignItems:'flex-start'}}>
 <span style={{fontSize:14,flexShrink:0}}>{a.ic}</span>
 <span style={{fontSize:11,color:C.text,flex:1,lineHeight:1.4}}>{a.msg}</span>
 <span style={{fontSize:12,color:a.c,fontWeight:700}}>→</span>
 </div>
 ))}
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}
